import React from 'react'
import { connect } from 'react-redux'
import { withOktaAuth } from '@okta/okta-react'
import { IOktaContext } from '@okta/okta-react/bundles/types/OktaContext'
import { LoginBackground } from './LoginBackground'
import { ConnectionActions } from 'store/connection'

interface LoginIdpDiscoveryProps extends IOktaContext {
  signOut: typeof ConnectionActions.signOut
}

const mapDispatchToProps = {
  signOut: ConnectionActions.signOut
}

class LoginIdpDiscoveryComponent extends React.Component<LoginIdpDiscoveryProps> {
  async componentDidMount() {
    const { oktaAuth, signOut } = this.props
    try {
      const res = await oktaAuth.token.getWithoutPrompt()
      oktaAuth.handleLoginRedirect(res.tokens)
    } catch (error) {
      signOut(error instanceof Error ? `${error.name}: ${error.message}` : undefined)
    }
  }

  render() {
    return <LoginBackground showSpinner={true} />
  }
}

export const LoginIdpDiscovery = connect(null, mapDispatchToProps)(withOktaAuth(LoginIdpDiscoveryComponent))
